import {
  TASK_TYPE_LIST_REQUEST,
  TASK_TYPE_LIST_SUCCESS,
  TASK_TYPE_LIST_FAIL,
} from "../constants/taskTypeConstants";

export const taskTypeListReducer = (state = {}, action) => {
    switch (action.type) {
      case TASK_TYPE_LIST_REQUEST:
        return { loading: true };
      case TASK_TYPE_LIST_SUCCESS:
        return { loading: false, taskTypes: action.payload };
      case TASK_TYPE_LIST_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
